import { Navigate, useSearchParams } from 'react-router-dom';

/** Old full-page URL → dashboard + modal. */
export default function AgentLegacySelectBotRedirect() {
  const [params] = useSearchParams();
  const returnTo = params.get('returnTo');
  const qs = new URLSearchParams();
  qs.set('pickBot', '1');
  if (returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
    qs.set('returnTo', returnTo);
  }
  return <Navigate to={`/dashboard?${qs.toString()}`} replace />;
}
